import React, { Component } from 'react';
import {HashRouter, Route, Switch, Redirect} from 'react-router-dom';
import Home from './home/Home';
import ViewResult from './home/ViewResult';
import Question from './question/Question';
import WrongQuestions from './wrong/WrongQuestions';
import './Base.css';
class App extends Component {
  render() {
    return (
      <div className="App">
          <HashRouter>
              <Switch>
                  <Route exact path="start/2" component={Home}/>
                  <Route path="/question/:eid/:eurl/take/:type" component={Question}/>
                  <Route path="/viewResult/wrong/" component={WrongQuestions}/>
                  <Route path="/viewResult" component={ViewResult}/>
              </Switch>
          </HashRouter>
      </div>
    );
  }
}

export default App;
